import {useLocation} from '@github-ui/react-router'

import type {ImmersivePlugin} from '../plugin/copilot-immersive-plugin'
import {getActivePluginFromLocation} from '../plugin/get-active-plugin-from-location'
import {usePlugins} from '../plugin/ImmersivePluginsProvider'
import {copilotFeatureFlags} from '../utils/copilot-feature-flags'
import {useChatStateValue} from '../utils/CopilotChatContext'

export function useActivePlugin(): ImmersivePlugin | undefined {
  const plugins = usePlugins()
  const activePlugin = useChatStateValue('activePlugin')
  const location = useLocation()

  if (copilotFeatureFlags.improvedNavigation) {
    return getActivePluginFromLocation(location, plugins)
  } else {
    return activePlugin ? plugins.find(p => p.id === activePlugin) : undefined
  }
}
